import { useMutation } from '@connectrpc/connect-query';

import { logout } from '../../../gen/user/v1/user-UserService_connectquery';
import { LOGIN_PATH } from '../login';
import { clearSessionToken } from '../session';

export const useLogout = () => {
	const { mutate, isPending } = useMutation(logout, {
		onSettled: () => {
			clearSessionToken();
			window.location.assign(LOGIN_PATH);
		},
	});

	return { logout: () => mutate({}), isPending };
};
